/**
 * StubHub Affiliate Ticket Button
 *
 * Checks Ticketmaster's Discovery API for upcoming music events for the artist
 * on this product page. The button is always visible:
 *   - While checking: grayed out (loading state)
 *   - Events found:   active blue button with Partnerize affiliate link
 *   - No events:      grayed out tombstone "No Upcoming Shows on StubHub"
 *
 * Handles multiple instances on the same page (e.g. main form + sticky bar).
 *
 * SETUP — replace these two values before deploying:
 *   TICKETMASTER_API_KEY  → https://developer.ticketmaster.com (free, 5k req/day)
 *   PARTNERIZE_CAMREF     → your Partnerize campaign reference (Partnerize dashboard)
 */

(function () {
  // ─── Configuration ─────────────────────────────────────────────────────────
  var TICKETMASTER_API_KEY = 'IF6u3OlpjMypsgoalwUqA6NgPQZ9Np2a';
  var PARTNERIZE_CAMREF    = '5saQ1M1lbC';
  // ───────────────────────────────────────────────────────────────────────────

  var STUBHUB_SEARCH_BASE = 'https://www.stubhub.com/find/s/?q=';
  var PARTNERIZE_BASE     = 'https://prf.hn/click/camref:' + PARTNERIZE_CAMREF + '/destination:';

  // Guard against placeholder values — do nothing until keys are set.
  if (
    TICKETMASTER_API_KEY === 'YOUR_TICKETMASTER_API_KEY' ||
    PARTNERIZE_CAMREF === 'YOUR_PARTNERIZE_CAMREF'
  ) {
    console.warn('[StubHub] Replace TICKETMASTER_API_KEY and PARTNERIZE_CAMREF in stubhub-affiliate.js before going live.');
    return;
  }

  // Only run once per page even though the script tag may appear multiple times
  // (once per add-to-cart-form render).
  if (window.__stubhubChecked) return;
  window.__stubhubChecked = true;

  // Collect ALL button instances — main form and sticky bar.
  var containers = document.querySelectorAll('.stubhub-btn-wrap');
  if (!containers.length) return;

  // Artist name is the same on all instances; read from the first.
  var artistName = (containers[0].dataset.artist || '').trim();
  if (!artistName) return;

  function applyToAll(fn) {
    for (var i = 0; i < containers.length; i++) {
      fn(containers[i]);
    }
  }

  function activate(affiliateUrl) {
    applyToAll(function (container) {
      var link = container.querySelector('.stubhub-ticket-btn');
      if (!link) return;
      link.href = affiliateUrl;
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
      link.classList.remove('stubhub-ticket-btn--loading', 'stubhub-ticket-btn--none');
      var labelActive = link.querySelector('.stubhub-btn-label--active');
      var labelNone   = link.querySelector('.stubhub-btn-label--none');
      if (labelActive) labelActive.style.display = '';
      if (labelNone)   labelNone.style.display   = 'none';
    });
  }

  function tombstone() {
    applyToAll(function (container) {
      var link = container.querySelector('.stubhub-ticket-btn');
      if (!link) return;
      link.href = '#';
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.classList.remove('stubhub-ticket-btn--loading');
      link.classList.add('stubhub-ticket-btn--none');
      var labelActive = link.querySelector('.stubhub-btn-label--active');
      var labelNone   = link.querySelector('.stubhub-btn-label--none');
      if (labelActive) labelActive.style.display = 'none';
      if (labelNone)   labelNone.style.display   = '';
    });
  }

  var today = new Date();
  var startDateTime = today.toISOString().replace(/\.\d{3}Z$/, 'Z');

  var apiUrl = [
    'https://app.ticketmaster.com/discovery/v2/events.json',
    '?apikey=', encodeURIComponent(TICKETMASTER_API_KEY),
    '&keyword=', encodeURIComponent(artistName),
    '&classificationName=music',
    '&size=1',
    '&sort=date,asc',
    '&startDateTime=', startDateTime,
  ].join('');

  fetch(apiUrl)
    .then(function (res) {
      if (!res.ok) throw new Error('Ticketmaster API error: ' + res.status);
      return res.json();
    })
    .then(function (data) {
      var events = data._embedded && data._embedded.events;
      if (!events || events.length === 0) {
        tombstone();
        return;
      }

      // Keyword search is broad — confirm at least one event has an attraction
      // (performer) whose name exactly matches the artist, so tribute shows,
      // exhibitions, and other loose keyword matches don't trigger the button.
      var normalizedArtist = artistName.toLowerCase().trim();
      var hasMatch = false;
      for (var i = 0; i < events.length; i++) {
        var attractions = events[i]._embedded && events[i]._embedded.attractions;
        if (!attractions) continue;
        for (var j = 0; j < attractions.length; j++) {
          if (attractions[j].name && attractions[j].name.toLowerCase().trim() === normalizedArtist) {
            hasMatch = true;
            break;
          }
        }
        if (hasMatch) break;
      }

      if (hasMatch) {
        var stubhubSearchUrl = STUBHUB_SEARCH_BASE + encodeURIComponent(artistName);
        var affiliateUrl = PARTNERIZE_BASE + encodeURIComponent(stubhubSearchUrl);
        activate(affiliateUrl);
      } else {
        tombstone();
      }
    })
    .catch(function (err) {
      tombstone();
      if (typeof console !== 'undefined') {
        console.warn('[StubHub] Could not fetch events:', err.message);
      }
    });
})();
